import {
    useGetLastDancesQuery,
    useGetSearchDancesQuery,
    useI18n,
} from 'store/Store'
import {useSearchParams} from 'react-router-dom'

const useMain = () => {
    const {i18n} = useI18n()
    const [searchParams] = useSearchParams()
    const search = searchParams.get('search')

    const {data: lastDances, isLoading: isLastDancesLoading} =
        useGetLastDancesQuery(null, {skip: search})

    const {data: foundDances, isLoading: isSearchDancesLoading} =
        useGetSearchDancesQuery(search, {
            skip: !search,
        })

    const title = search ? i18n.t('main.searchTitle') : i18n.t('main.title')

    console.log('is loading', isLastDancesLoading, isSearchDancesLoading)
    return {
        dances: search ? foundDances : lastDances,
        title,
        isLoading: isLastDancesLoading || isSearchDancesLoading,
    }
}

export default useMain
